import { PureComponent, ReactNode } from 'react';
import { track } from '../tracking';

class NewIpadAppAvailablePage extends PureComponent {
    openIpadAppStore = () => {
        track('IPAD_TRY_NOW');
        window.open('https://apps.apple.com/in/app/ekadocpad/id6444757746');
    };

    render(): ReactNode {
        return (
            <div className="font-lato font-700 p-24 h-full w-full overflow-auto hide-scrollbar">
                <div className=" flex items-center space-x-12 bg-darwin-status-warning-300 px-50 py-20 rounded-24">
                    <svg
                        className="w-24 h-24 fill-white"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path d="M12 -6.10352e-05C5.34375 -6.10352e-05 0 5.39056 0 11.9999C0 18.6562 5.34375 23.9999 12 23.9999C18.6094 23.9999 24 18.6562 24 11.9999C24 5.39056 18.6094 -6.10352e-05 12 -6.10352e-05ZM10.875 7.12494C10.875 6.51556 11.3438 5.99994 12 5.99994C12.6094 5.99994 13.125 6.51556 13.125 7.12494V13.1249C13.125 13.7812 12.6094 14.2499 12 14.2499C11.3438 14.2499 10.875 13.7812 10.875 13.1249V7.12494ZM12 18.7499C11.1562 18.7499 10.5 18.0937 10.5 17.2968C10.5 16.4999 11.1562 15.8437 12 15.8437C12.7969 15.8437 13.4531 16.4999 13.4531 17.2968C13.4531 18.0937 12.7969 18.7499 12 18.7499Z" />
                    </svg>

                    <p className="font-18 text-white">
                        We do not support this version of the EMR anymore. Don't worry your data is
                        safe. You can try the newly launched EkaDocPad
                    </p>
                </div>

                <div
                    className="text-center mx-auto my-24"
                    style={{ fontSize: '34px', lineHeight: '48px', width: '540px' }}
                >
                    Introducing the all new{' '}
                    <span className="text-darwin-accent-bright-blue-800">EkaDocPad</span> - Doctor's
                    EMR on iPAD
                </div>

                <div className="flex items-center justify-center space-x-32">
                    <div className="flex items-center space-x-16">
                        <div className="flex items-center justify-center w-48 h-48 rounded-full bg-darwin-accent-green-800">
                            <svg
                                className="w-16 h-20 fill-white"
                                viewBox="0 0 16 21"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path d="M14.7977 11.5806L5.06988 20.0876C4.80285 20.3165 4.49766 20.3928 4.23062 20.3928C3.96358 20.3928 3.69655 20.3165 3.50581 20.1639C3.04803 19.8587 2.85729 19.2484 3.08618 18.7143L6.02359 11.8476H1.78914C1.25506 11.8476 0.797282 11.5424 0.644689 11.0846C0.453948 10.5887 0.568392 10.0546 0.949875 9.71131L10.7158 1.20425C11.1355 0.822768 11.7458 0.822768 12.2036 1.1661C12.6995 1.47129 12.8521 2.08166 12.6232 2.61574L9.68582 9.44427H13.9584C14.4543 9.44427 14.9121 9.7876 15.1029 10.2454C15.2936 10.7032 15.1792 11.2372 14.7977 11.5806Z" />
                            </svg>
                        </div>
                        <p>Fully Customisable</p>
                    </div>

                    <div className="flex items-center space-x-16">
                        <div className="flex items-center justify-center w-48 h-48 rounded-full bg-darwin-accent-bright-yellow-800">
                            <svg
                                className="w-16 h-20 fill-white"
                                viewBox="0 0 16 21"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path d="M14.7977 11.5806L5.06988 20.0876C4.80285 20.3165 4.49766 20.3928 4.23062 20.3928C3.96358 20.3928 3.69655 20.3165 3.50581 20.1639C3.04803 19.8587 2.85729 19.2484 3.08618 18.7143L6.02359 11.8476H1.78914C1.25506 11.8476 0.797282 11.5424 0.644689 11.0846C0.453948 10.5887 0.568392 10.0546 0.949875 9.71131L10.7158 1.20425C11.1355 0.822768 11.7458 0.822768 12.2036 1.1661C12.6995 1.47129 12.8521 2.08166 12.6232 2.61574L9.68582 9.44427H13.9584C14.4543 9.44427 14.9121 9.7876 15.1029 10.2454C15.2936 10.7032 15.1792 11.2372 14.7977 11.5806Z" />
                            </svg>
                        </div>
                        <p>Designed for ipad </p>
                    </div>

                    <div className="flex items-center space-x-16">
                        <div className="flex items-center justify-center w-48 h-48 rounded-full bg-darwin-accent-mauve-800">
                            <svg
                                className="w-16 h-20 fill-white"
                                viewBox="0 0 16 21"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path d="M14.7977 11.5806L5.06988 20.0876C4.80285 20.3165 4.49766 20.3928 4.23062 20.3928C3.96358 20.3928 3.69655 20.3165 3.50581 20.1639C3.04803 19.8587 2.85729 19.2484 3.08618 18.7143L6.02359 11.8476H1.78914C1.25506 11.8476 0.797282 11.5424 0.644689 11.0846C0.453948 10.5887 0.568392 10.0546 0.949875 9.71131L10.7158 1.20425C11.1355 0.822768 11.7458 0.822768 12.2036 1.1661C12.6995 1.47129 12.8521 2.08166 12.6232 2.61574L9.68582 9.44427H13.9584C14.4543 9.44427 14.9121 9.7876 15.1029 10.2454C15.2936 10.7032 15.1792 11.2372 14.7977 11.5806Z" />
                            </svg>
                        </div>
                        <p>Superfast </p>
                    </div>
                </div>

                <div className="text-center">
                    <button
                        onClick={this.openIpadAppStore}
                        className="px-72 py-12 text-white bg-darwin-accent-bright-blue-800 rounded-8 my-34 font-700"
                    >
                        Try it now
                    </button>
                </div>

                <div className="relative flex items-center justify-center h-592 overflow-hidden">
                    <img
                        src="/images/Ipad1.png"
                        alt="#"
                        className="h-592 w-840 border-4 rounded-16 border-darwin-accent-bright-blue-800"
                    />
                    <img
                        src="/images/Ipad2.png"
                        alt="#"
                        className="absolute bottom-0"
                        style={{ width: '940px' }}
                    />
                </div>
            </div>
        );
    }
}

export default NewIpadAppAvailablePage;
